import { render, staticRenderFns } from "./NewDSimpleSelectPreview.vue?vue&type=template&id=4dec7cda&"
import script from "./NewDSimpleSelectPreview.vue?vue&type=script&lang=js&"
export * from "./NewDSimpleSelectPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports